import { render, staticRenderFns } from "./OfferDetails.vue?vue&type=template&id=587a6a44&"
import script from "./OfferDetails.vue?vue&type=script&lang=js&"
export * from "./OfferDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelzickert/Development/capture-studio/capture-studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('587a6a44')) {
      api.createRecord('587a6a44', component.options)
    } else {
      api.reload('587a6a44', component.options)
    }
    module.hot.accept("./OfferDetails.vue?vue&type=template&id=587a6a44&", function () {
      api.rerender('587a6a44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/offer/OfferDetails.vue"
export default component.exports